module.exports = __webpack_public_path__ + "img/logo.68e2d45f.png";